import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;

  .ant-alert {
    display: flex;
    border-radius: 0;
  }

  .ant-card-body {
    height: 100%;
  }
`;
